export default __webpack_public_path__ + "static/media/appartment.97d19e35.png";